import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../app/App";

interface TimeRangeSelectorProps {
    confirm: (afterTimestamp: number) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ confirm }) => {
    const { theme } = useContext(ThemeContext);
    const [ afterTime, setAfterTime ] = useState<moment.Moment | null>(null);

    useEffect(() => {
        const today = moment();
        const beginningOfYesterday = today.startOf("day").subtract(1, "day");
        setAfterTime(beginningOfYesterday);
    }, []);

    return (
        <div className="column-centered">
            <div className="column-centered my-bw-5 my-5">
                <p className="">Collect songs listened to since: </p>
                <p className="font-bold">{afterTime !== null ? afterTime.format("MMMM Do YYYY HH:MM a") : ' n/a'}</p>
            </div>
            <button className={`button border border-${theme === 'dark' ? 'white' : 'gray-700'} rounded-lg px-3 py-1`} onClick={() => afterTime ? confirm(parseInt(String(afterTime.unix()).padEnd(13, '0'))) : {}} disabled={afterTime === null}>Collect Songs</button>
        </div>
    )
}

export default TimeRangeSelector;
